import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Typography, RadioGroup, FormControlLabel, FormHelperText, Radio } from '@material-ui/core';
import { Field } from 'react-final-form';
import FormTextField from './FormTextField';

const FormRadioGroup = ({
  input,
  label,
  meta: { touched, error },
  values,
  disabled,
  allowOwnAnswer,
  ownAnswerName,
  ownAnswerFieldName,
  ...custom
}) => (
    <FormControl component="fieldset" error={touched && error ? true : false} disabled={disabled} fullWidth>
      {label && <Typography variant="caption" gutterBottom color="textSecondary" style={error ? { color: 'red' } : {}}>{label}</Typography>}
      <RadioGroup
        aria-label={label}
        value={input.value}
        onClick={event => input.onChange(event.target.value)}
        {...custom}
      >
        {values.map(value => (
          <FormControlLabel
            key={value.value}
            value={value.value}
            control={<Radio color="primary" />}
            label={value.subtitle
              ? <React.Fragment>
                  <Typography>{value.name}</Typography>
                  <Typography variant="caption" color="textSecondary">{value.subtitle}</Typography>
                </React.Fragment>
              : value.name} />
              
        ))}
        {allowOwnAnswer && <FormControlLabel value="own" control={<Radio color="primary" />} label={ownAnswerName} />}
      </RadioGroup>
      {allowOwnAnswer && input.value && input.value === "own"
      ? <div>
          <Field
            name={ownAnswerFieldName}
            label={ownAnswerName}
            placeholder="Wpisz własną odpowiedź"
            component={FormTextField}
            disabled={disabled}
            fullWidth
          />
        </div>
      : null}
      {touched && error ? <FormHelperText id="radio-error-text" error style={{ marginTop: 0 }}>{error}</FormHelperText> : null}
    </FormControl>
  );

FormRadioGroup.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  values: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  allowOwnAnswer: PropTypes.bool,
  ownAnswerName: PropTypes.string,
  ownAnswerFieldName: PropTypes.string,
};

export default FormRadioGroup;



// WEBPACK FOOTER //
// ./src/components/form/FormRadioGroup.js